import User from './user';

export const OPEN_ITEM_STATUS = {
  NOT_STARTED: 'not_started',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
};

// Single source of truth for the open item status enum -> label mapping,
// reused by the create/edit form, the accelerate picker, the table column,
// and the details view (mirrors the {value, label} options pattern used by
// domain/punch-list.js for its own status/priority selects).
export const openItemStatusOptions = [
  { value: OPEN_ITEM_STATUS.NOT_STARTED, label: 'Not Started' },
  { value: OPEN_ITEM_STATUS.IN_PROGRESS, label: 'In Progress' },
  { value: OPEN_ITEM_STATUS.COMPLETED, label: 'Completed' },
];

// Accelerating an open item means it is no longer Not Started, so the
// picker shown from the Accelerate action only offers the other two.
export const openItemAccelerateStatusOptions = openItemStatusOptions.filter(
  (option) => option.value !== OPEN_ITEM_STATUS.NOT_STARTED
);

export const openItemStatusLabel = (status) => {
  const option = openItemStatusOptions.find((opt) => opt.value === status);
  return option ? option.label : '';
};

class OpenItem {
  isCreatedByUserCompany = (user, openItem) =>
    !!openItem &&
    !!openItem.created_by &&
    User.isSameCompany(user, openItem.created_by);

  isCreatedByGcOar = (directory, openItem) =>
    !!openItem &&
    !!openItem.created_by &&
    User.isGcOar(User.userContributor(directory, openItem.created_by));

  isCreatorUser = (user, openItem) =>
    !!openItem && openItem.created_by && openItem.created_by.id === user.id;

  isAssignedToUser = (user, openItem) =>
    !!openItem && openItem.assignee_id === user.id;
}

export default new OpenItem();
